import { useState } from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';

import windowCheck from 'utils/helpers/window-check';

import BlogSearch from 'components/modal/blog-search';
import Signups from 'components/modal/signups';

import './styles/categories.scss';
import Subscribe from '../modal/subscribe';

type NavigationCategoriesProps = {
  activeCategory?: string,
  hideCategoryDescription?: boolean
}

const NavigationCategories = ({ activeCategory, hideCategoryDescription }: NavigationCategoriesProps) => {
  const data = useStaticQuery(graphql`
    {
      allWordpressWpAllCategoriesMenu{
        nodes {
          title
          url
          post_name
          description
        }
      }

      allWordpressAcfOptions {
        edges {
          node {
            options {
              subscribe_modal {
                title
                image {
                  source_url
                }
              }
            }
          }
        }
      }
    }
  `);

  const allCategories = data.allWordpressWpAllCategoriesMenu.nodes;
  const modalContent =
    data.allWordpressAcfOptions.edges[0].node.options.subscribe_modal;
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  let displayCategory = allCategories.find(category => category.url === `/${activeCategory}`);
  if (!displayCategory) {
    displayCategory = {
      title: 'All Categories',
      description: 'Explore Valuable Insights on the When I Work Blog',
    };
  }

  return (
    <nav className="categories-navigation" data-section="category navigation">
      <div className="container">
        <ul className="categories">
          <li
            className={ `dropdown ${isDropdownOpen ? 'is-active' : ''}` }
            onClick={ () => setIsDropdownOpen(!isDropdownOpen) }
          >
            <div className="dropdown-trigger">
              <button
                className="dropdown-button"
                aria-haspopup="true"
                aria-controls="dropdown-menu"
              >
                <span className="dropdown-title">{ displayCategory.title }</span>
                <span
                  className={ `icon is-small ${
                    isDropdownOpen ? 'icon-flip' : ''
                  }` }
                />
              </button>
            </div>
            { !hideCategoryDescription && <h1 className="categories-description">{ displayCategory.description }</h1> }
            <div className="dropdown-menu" id="dropdown-menu" role="menu">
              <ul className="dropdown-content">
                {allCategories.map((category, index) => {
                  return (
                    <li key={ index }>
                      <Link
                        tabIndex={ isDropdownOpen ? 0 : -1 }
                        to={ `/blog${category.url}` }
                        className={
                          windowCheck &&
                          window.location.pathname === `/blog${category.url}`
                            ? 'is-active dropdown-item '
                            : 'dropdown-item'
                        }
                      >
                        {category.title}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          </li>
        </ul>
        <BlogSearch />
        <Subscribe formType="blogSubscription" { ...modalContent } />
        <div className="start-trial is-hidden-mobile">
          <Signups
            uniqueId="categoriesNav"
            longPlaceholder
            fieldLayout="row"
            buttonClasses="button is-signup-button is-rounded"
            showModalButton
            ctaVariation='Blog header + modal'
          />
        </div>
      </div>
    </nav>
  );
};

export default NavigationCategories;
